import OspreyApiHelper from './helper'

export default class OspreyTypedValues {

    static get(path, params) {
        return OspreyApiHelper.genericGet(path, params)
    }
    
    static post(path, params) {
        return OspreyApiHelper.genericPost(path, params)
    }
}


// WEBPACK FOOTER //
// src/services/osprey-api/api-typed-values.js